import { reloadCountSource } from '../data/busSources.js';
import type { PartialContext } from '../types/Context.js';

export interface NotifyReloadOptions {
  reason: string;
}

/**
 * Notifies clients that a reload is needed by incrementing the session version.
 */
export async function notifyReload(
  options: NotifyReloadOptions,
  context: PartialContext<'bus' | 'telemetryClient', 'sequence'>,
): Promise<void> {
  const { reason } = options;
  const { bus, session, telemetryClient } = context;

  await telemetryClient.tracer.startActiveSpan('NOTIFY_RELOAD', (span) => {
    session.sequence++;

    span.setAttributes({ sequence: session.sequence, reason });

    // Publish using .path for easier testing
    bus.publish(reloadCountSource.path, session.sequence);
  });
}
